// «Додано N товарів» announcements (T-574) and products that left or came back to a store (T-579). The
// server decides what is news; the browser only remembers which announcements it already showed, so each
// viewer sees a toast once per browser.

export interface StoreSyncAddedNotice {
  id: string
  kind?: 'added' | 'presence'
  store_id: number
  added_count: number
  message: string
  notified_at: string
}

export function seenNoticesStorageKey(orgId: string) {
  return `mph.store-sync-added.${orgId}`
}

export function readSeenNoticeIds(storage: Pick<Storage, 'getItem'> | null, key: string): string[] {
  try {
    const parsed: unknown = JSON.parse(storage?.getItem(key) || '[]')
    return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : []
  } catch {
    return []
  }
}

// Returns the notices to show (oldest first) and the seen ids to store. Only ids the server still returns
// are kept, so the stored list stays bounded by the server's one-day window.
export function takeUnseenNotices(notices: StoreSyncAddedNotice[], seenIds: string[]) {
  const seen = new Set(seenIds)
  const unseen = notices.filter((notice) => !seen.has(notice.id) && notice.message)
  return {
    unseen: [...unseen].sort((a, b) => a.notified_at.localeCompare(b.notified_at)),
    nextSeenIds: notices.map((notice) => notice.id),
  }
}
